import React from "react";
import { createUseStyles } from "react-jss";

import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import colors from "../../constants/colors";

import useCopyToClipboard from "../../utils/hooks/useCopyToClipboard";

const useStyles = createUseStyles({
  default: {
    padding: 0,
    border: 0,
    outline: "none",
    backgroundColor: "transparent",
  },
});

export const ClipboardCopyButton = ({ code, interval = 2000 }) => {
  const styles = useStyles();
  // isCopied is reset after 2 second timeout
  const [isCopied, setCopied] = useCopyToClipboard(code, { interval });

  return (
    <button className={styles.default} type="button" onClick={setCopied}>
      <ContentCopyOutlinedIcon
        fill={isCopied ? colors.svg.secondary : colors.svg.primary}
      />
    </button>
  );
};
